import { cn } from '@dashboard/ui'
import { ReactNode } from 'react'
import { NavLink } from 'react-router-dom'

export interface TabType {
  link?: string
  onClick?: () => void
  isActive?: boolean
  title: string
}

interface TabsProps {
  tabs: TabType[]
  extra?: ReactNode
}

export const TabsNavigation = ({ tabs, extra }: TabsProps) => {
  return (
    <>
      {tabs && (
        <section className="flex w-full flex-row justify-between gap-2 border-b border-border-secondary">
          <div className="flex gap-2">
            {tabs.map(tab => (
              <div key={tab.link}>
                {tab.link && (
                  <NavLink end className="group" to={tab.link}>
                    <div className="cursor-pointer border-border-brand pb-2 group-[.active]:border-b">
                      <p className="cursor-pointer rounded-lg p-2 hover:bg-fg-secondary group-[.active]:font-semibold">
                        {tab.title}
                      </p>
                    </div>
                  </NavLink>
                )}
                {tab.onClick && (
                  <div className={cn('cursor-pointer border-border-brand pb-2', tab.isActive && 'border-b')}>
                    <p
                      onClick={tab.onClick}
                      className={cn(
                        'cursor-pointer rounded-lg p-2 hover:bg-fg-secondary',
                        tab.isActive && 'font-semibold',
                      )}
                    >
                      {tab.title}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
          {extra && <div className="flex items-center gap-3">{extra}</div>}
        </section>
      )}
    </>
  )
}
